import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../theme';

export const useQuoteBadgeStyles = createStyles(({ token }) => ({
  quoteBadgeSection: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 6,
    gap: ThemeSpaces.SPACE_MD,
  },
  inlineLink: {
    color: token.colorPrimary,
    textDecoration: 'underline',
    fontWeight: 700,
  },
  iconButton: {
    padding: `${token.paddingXS}px 6px`,
    flexDirection: 'row',
    backgroundColor: ThemeColors.COLOR_WHITE3,
    borderRadius: token.borderRadiusSM,
    border: `1px solid ${ThemeColors.COLOR_GREY7_75}`,

    '.fa-chevron-circle-right': {
      fontSize: token.fontSize,
      color: token.colorPrimary,
    },

    'div.IconButton-Label': {
      color: token.colorPrimary,
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      marginLeft: 6,
    },
  },
  badge: {
    padding: `${ThemeSpaces.SPACE_XXS}px ${token.paddingSM}px`,
    borderRadius: token.borderRadiusSM,
    color: token.colorWhite,
    cursor: 'default',
  },
  badgeBooked: {
    backgroundColor: ThemeColors.COLOR_BLUE2,
  },
  badgeExpired: {
    backgroundColor: ThemeColors.COLOR_GREY7_2,
  },
}));
